import { render, staticRenderFns } from "./CourseSearchSlidebar.vue?vue&type=template&id=3272cc8f"
import script from "./CourseSearchSlidebar.vue?vue&type=script&lang=js"
export * from "./CourseSearchSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports